import workspaceQuery from '../../queries/system/JobReportWorkspaceQuery.graphql';
import instanceQuery from '../../queries/system/JobReportQuery.graphql';
import fragment from '../../fragments/system/JobReportFragment.graphql';
import { EntityType } from '../../../@types/entityTypes';
import { ALLOW_VIEW } from '../../../utils/OperationPermissions';

const JobReport: EntityType = {
  type: 'JobReport',
  title: 'Job Reports',
  formTitle: 'Job Report',
  formUrl: '/System/JobReport/Details/',
  workspaceUrl: '/System/JobReport/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  fragment,
  screenReference: 'JOB_REPORT',
  operations: ALLOW_VIEW,
};

export default JobReport;
